<template>
  <div class="container">
		<div class="conmonContent">
			<div class="w1600">
				<div class="proTop d-flex j-sb a-start">
					<div class="ptLeft">
						<h3 class="font36 corfff h3">{{ $t('topMenu.activity') }}</h3>
					</div>
					<!-- 筛选 -->
					<div class="searchblock">
						<search search_type="activity" :isRederect="false" @search="handleSearch"></search>
					</div> 
				</div>
				 
				 <!-- 主体列表内容 -->
				 <div :class="['documentContent d-flex j-sb', {active: handleType}]">
					 <!-- 移动端显示分类 -->
					 <div class="handleType a-center j-center" @click="handleType = !handleType">{{ $t('show.category') }}<img src="@/assets/Icons/type.svg" alt="" /></div>
					 <!-- 左侧分类 -->
					 <!-- 右侧列表 -->
					 <div class="proDocument">
						 <div class="conmonDocument bd10">
							 <!-- 筛选 -->
							 <div class="filter d-flex j-sb a-center">
								<div class="showNums d-flex a-center font-light">
									 {{ $t('filter.page',{a:1,b:pagination.pageSize,c:total}) }}
									 <select name="" v-model="pagination.pageSize" @change="getActivityVOList" id="" class="font-light">
										<option value="10">{{ $t('filter.pageSize',{a:10}) }}</option>
										<option value="30">{{ $t('filter.pageSize',{a:30}) }}</option>
										<option value="50">{{ $t('filter.pageSize',{a:50}) }}</option>
										<option value="100">{{ $t('filter.pageSize',{a:100}) }}</option>
									 </select>
								 </div>
								 <div class="rForm d-flex a-center">
									 <div class="sort d-flex a-center">
										 
										 <select v-model="pagination.orderBy" @change="handelSort" class="font-light">
												<option value="timeDesc">{{ $t('filter.bynew') }}</option>
												<option value="timeAsc">{{ $t('filter.byold') }}</option>
												<option value="titleDesc">{{$t('filter.bytitle')}}</option>
										 </select>
										 <select v-model="pagination.activityType" @change="handelSort" class="font-light">
												<option value="">{{ $t('show.activityType') }}</option>
												<option value="1">{{ $t('show.offlineActivity') }}</option>
												<option value="2">{{ $t('show.onlineActivity') }}</option>
										 </select>
										 <img src="@/assets/Icons/sort.png" alt="">
									 </div>
								 </div>
								  
							 </div>
						 </div>
						 <!-- 列表 -->
						 <div class="trainList naList">
							 <ul class="d-flex f-wrap">
								 <li  class="pointer" v-for="(item, index) in activityVOList" :key="index">
									 <div class="text scale d-flex j-sb">
										 <figure class="pointer pr">
											 <img :src="item.cover" class="t-sion" :alt="item.title">
										 </figure>
										 <div class="intro">
											 <h3 class="nowrap2 h3 font20 font-medium line-sm">
												<a class="link">{{item.title}}</a>
												<span v-if="item.applyType == 1" class="font16 font-light entry pointer">{{$t('activity.notStarted')}}</span>
												<span v-if="item.applyType == 2" class="font16 font-light entry pointer">{{$t('activity.inProgress')}}</span>
												<span v-if="item.applyType == 3" class="font16 font-light entry gray">{{$t('activity.ended')}}</span>
											</h3>
											 <p class="nowrap2 cor999 font-light">{{item.description}}</p>
											 <div class="handle2 d-flex j-sb a-end">
												<div class="ll">
													<div class="date1 line-sm"><span>{{$t('show.activityDate')}}:</span>{{item.time}}</div>
										 			<div class="date2 line-sm"><span>{{$t('show.registrationDate')}}:</span>{{item.applyBeginDate+'-'+item.applyEndDate}}</div>
										 			<div class="type line-sm" v-if="item.activityType"><span>{{$t('show.activityType')}}:</span>{{item.activityType==1?$t('show.offlineActivity'):$t('show.onlineActivity')}}</div>
												</div>
												 <div class="btns d-flex" v-if="item.activityLink">
													<a :href="item.activityLink" target="_blank" class="lookDetail">{{$t('show.lookDetail')}}</a>
												 </div>
											 </div>
										 </div>
									 </div>
								 </li>
							 </ul>
						 </div>
						 <!-- 分页 -->
						 <div class="pagination">
						 	 <el-pagination
						 		   @current-change="handleCurrentChange"
						 		   :page-size="10"
						 		   layout="prev, pager, next"
						 		   :total="total">
						 	</el-pagination>
						 </div>
					 </div>
				 </div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: 'Activity',
  components: {
    
  },
  data() {
    return {
		// 控制移动端分类的显示/隐藏
		handleType: false,
		// 左侧分类
		leftMenu: [],
		// 左侧菜单选中
		leftMenuChecked: 1,
		// 活动列表
		activityVOList: [],
		categoryKeys:[],
		// 分页
		pagination: {
			pageNo: 1,
			pageSize: 10,
			keyword: '',
			activityType:'',
			orderBy:'timeDesc'
		},
		// 数量
		total: 0
	}
  },
  
  created() {
	this.getCategory();
  	  // 获取活动
  	  this.getActivityVOList();
  },
  
  methods: {
  	  // 页面跳转
  	  goToPage(path, query={}) {
  		  this.$router.push({
  		  	path,
  			query
  		  })
  	  },
		selectCategory(key,value){
		var that=this;
		if(that.pagination[key]==value){
			that.pagination[key]=''
		}else{
			that.pagination[key]=value
		}
		that.pagination.pageNo=1;
		that.getActivityVOList();
	},
	getCategory(){
		var that=this;
		that.categoryKeys=[];
		this.$axios.get('knowledge/selectData')
		  .then(res => {
			  that.leftMenu = res.data;
			  Object.keys(that.leftMenu).forEach(function(key){
				if(!that.pagination[key]){
					that.$set(that.pagination,key,'');
					that.categoryKeys.push(key);
				}
			  });
		  })
		  .catch(err => {})
	},
	  // 获取列表
	  getActivityVOList() {
		  this.$axios.post('activity/page', this.pagination)
		  .then(res => {
			  this.activityVOList = res.data?.list?res.data.list:[];
			  this.total = res.data?.total?res.data.total:0;
		  })
		  .catch(err => {})
	  },
	  
	  // 点击翻页
	  handleCurrentChange(current) {
		  this.pagination.pageNo = current;
		  // 更新
		  this.getActivityVOList();
	  },
	  handelSort(){
            this.pagination.pageNo=1;
            this.getActivityVOList();
        },
		handleSearch(e){
			console.log(e)
			if(e.type=="activity"){
				if(!e.key) return;
				this.pagination.keyword=e.key;
				this.getActivityVOList();
			}else{
				this.$router.push({
					path:'/search',
					query:{
						type:e.type,
						kw:e.key
					}
				})
			};
		}
  }
}
</script>

<style lang="less" scoped>
	.proTop{
		padding: .5rem 0;
		.tags{
			span{
				display: inline-block;
				padding: 0.05rem 0.08rem;
				border-radius: 0.15rem;
				background: #5794f8;
				color: #fff;
				margin-right: .1rem;
			}
		}
		.cTopFrom{
			margin: 0;
		}
		@media (max-width: 1200px) {
			display: block;
			.cTopFrom{
				margin: .3rem auto 0;
			}
		}
	}
	.documentContent{
		.proDocument{
			width: 100%;
		}
		.trainList{
			ul{
				margin-top: 0;
				li{
					width: 100%;
					margin-top: .3rem;
					.text{
						align-items: stretch;
						border-radius: 0 0.1rem 0.1rem 0;
						figure{
							flex: 0 0 auto;
							width: 3.9rem;
							max-width: 30%;
							img{
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}
						.intro{
							flex: 1 1 auto;
							overflow: hidden;
							padding: 0.2rem 0.3rem 0.2rem 0.4rem;
							h3{
								a{
									line-height: 0.3rem;
								}
								span{
									margin-left: 1em;
									line-height: 0.3rem;
									display: inline-block;
									border-radius: 3px 3px 3px 0;
									position: relative;
									padding: 0 1em;
									background: #ff8400;
									font-weight: normal;
									color: #fff;
									position: relative;
									&:after{
										content: "";
										position: absolute;
										right: 100%;
										bottom: 0;
										border-right: 2px solid #ff8400;
										border-bottom: 2px solid #ff8400;
										border-top: 2px solid transparent;
										border-left: 2px solid transparent;
									}
									&.gray{
										background: #afbbd6;
										&:after{
											border-right: 2px solid #afbbd6;
											border-bottom: 2px solid #afbbd6;
										}
									}
								}
							}
							.btns{
								a{
								display: block;
								width: 1rem;
								border-radius: 3px;
								height: .4rem;
								background: #2147d7;
								color: #fff;
								text-align: center;
								line-height: .4rem;
								&:hover,&.entry{
									background: #2147d7;
									color: #fff;
								}
								&.entry.gray{
									background: #999;
								}
								&:not(:last-child) {
									margin-right: .1rem;
								}
							}
							}
						}
					}
				}
				
			}
		}
		@media (max-width: 640px) {
			.trainList{
				ul{
					li{
						.text{
							display: block;
							figure{
								width: auto;
								max-width: 100%;
							}
							.intro{
								padding: 0.2rem;
								.handle2{
									display: block;
									.btns{
										margin-top: 1em;
										display: block;
									}
								}
							}
						}
					}
				}
			}
		}
		.dcLeft{
			width: 18.75%;
			dl{
				padding: .3rem;
				&:not(:last-child) {
					margin-bottom: .1rem;
				}
				dt{
					margin-bottom: .3rem;
				}
				ul li{
					&:not(:last-child) {
						margin-bottom: .2rem;
					}
					&:hover,&.active{
						a{
							color: #3076e3;
						}
						span{
							background: #2657db;
							color: #fff;
						}
					}
					a{
						display: block;
						max-width: 85%;
					}
					span{
						padding: 0 .07rem;
						height: .2rem;
						border-radius: .2rem;
						background: #e4eef6;
						color: #7cacd0;
						margin-left: .1rem;
						line-height: .2rem;
						margin-top: -2px;
					}
				}
			}
		}
		@media (max-width: 1200px) {
			position: relative;
			overflow: hidden;
			.dcLeft{
				position: absolute;
				left: -230px;
				top: 0;
				width: 230px;
				transition: all .5s;
				dl{
					padding: .2rem;
				}
			}
			.proDocument{
				width: 100%;
				transition: all .5s;
			}
			&.active{
				.dcLeft{
					left: 0;
				}
				.proDocument{
					transform: translateX(240px);
				}
			}
		}
	}
	
	.proDocument{
		.pdLeft{
			width: 85%;
			.tagList{
				margin-top: .2rem;
				padding-left: .3rem;
			}
		}
		.conmonDocument{
			ul li{
				h3{
					width: 100%;
				}
			}
		}
	}
	
	.conmonDocument{
		padding: .3rem;
		.filter{
			flex-direction: row-reverse;
			.search{
				margin-left: .2rem;
				border-radius: 3px;
				border: solid 1px #eee;
				overflow: hidden;
				input{
					width: 2.8rem;
					padding: 0 .15rem;
					padding-right: .75rem;
				}
				button{
					position: absolute;
					right: 0;
					top: 0;
					width: .6rem;
					background: #2657db;
					color: #fff;
					&:hover{
						background: #003ee5;
					}
				}
				input,button{
					height: .33rem;
					font-size: .16rem;
				}
			}
			.sort{
				
				select{
					margin-right: .1rem;
					margin-left: 0;
				}
				img{
					width: .2rem;
				}
			}
			select{
				font-size: .16rem;
				width: 1.2rem;
				height: .35rem;
				border: solid 1px #eee;
				border-radius: 3px;
				padding-left: .15rem;
				margin-left: .2rem;
				background: url(@/assets/Icons/arrowDownGray.png) no-repeat 90% center/.15rem;
			}
		}
		@media (max-width: 640px) {
			.filter{
				display: block;
				.rForm{
					display: block;
					margin-top: 1em;
				}
				.search{
					margin: .2rem 0;
					input{
						width: calc(100% - .8rem);
						
					}
					button{
						width: .8rem;
					}
					input,button{
						height: .5rem;
						line-height: .5rem;
					}
				}
			}
			ul li{
				padding-right: 0;
			}
		}
	}
</style>
